export default __webpack_public_path__ + "static/media/DynamicMode.e2b14897.svg";